import { appStoreLenses } from 'root/src/client/logic/app/lenses'

const { viewCreatorCampaignPointsLimit } = appStoreLenses

export default viewCreatorCampaignPointsLimit
